import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { CookieService } from 'ngx-cookie';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RtbAuthService } from '../auth/rtb-auth.service';

@Injectable()
export class ReportComponentService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private rtbAuthService: RtbAuthService,
  ) {
    super(rtbAuthService);
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  public createCustomTemplate(fileContent: string, name: string, application: string): Observable<any> {
    let httpParams = new HttpParams();

    if (name) {
      httpParams = httpParams.set('name', name);
    }
    if (application !== null && application !== undefined) {
      httpParams = httpParams.set('application', application);
    }
    const headers = new HttpHeaders();
    headers.append('Content-Type', undefined);

    const formData = new FormData();
    formData.append('file', fileContent);

    return this.http.post<any>(`/api/ReportComponents/addComponent/`, formData, { headers: headers, params: httpParams })
      .pipe(map(response => response),
        catchError((error) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }
  public updateCustomTemplate(componentId: string, fileContent: string, name: string, application: string): Observable<any> {
    let httpParams = new HttpParams();

    if (name) {
      httpParams = httpParams.set('name', name);
    }
    if (application !== null && application !== undefined) {
      httpParams = httpParams.set('application', application);
    }
    if (componentId) {
      httpParams = httpParams.set('componentId', componentId);
    }
    const headers = new HttpHeaders();
    headers.append('Content-Type', undefined);

    const formData = new FormData();
    formData.append('file', fileContent);

    return this.http.post<any>(`/api/ReportComponents/updateComponent/`, formData,
      { headers: headers, params: httpParams })
      .pipe(map(response => response),
        catchError((error, caught) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }

  public deleteCustomTemplate(componentId: string) {
    let httpParams = new HttpParams();
    return this.http.delete(`api/ReportComponents/deleteComponent/${componentId}`,
      { headers: this.getTimeZoneHeader(), withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response),
        catchError((error, caught) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }

  public getCustomTemplates(application: string): Observable<any> {
    let httpParams = new HttpParams();
    if (application != null && application !== undefined) {
      httpParams = httpParams.set('application', application);
    }
    return this.http.get(`/api/ReportComponents/getComponents`,
      { headers: this.getTimeZoneHeader(), withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response),
        catchError((error, caught) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }

  public getReportCompopent(name: string): Observable<any> {
    return this.http.get(`/api/ReportComponents/getComponentByName/${name}`,
      { headers: this.getTimeZoneHeader(), withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response),
        catchError((error, caught) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }

  public getReportCompopentByUrl(url: string): Observable<any> {
    return this.http.get(url);
  }

  public getTemplateComponent(name: string): Observable<any> {
    return this.http.get(`/api/ReportComponents/getTemplateComponentByName/${name}`,
      { headers: this.getTimeZoneHeader(), withCredentials: super.getWithCredentialsOption() })
      .pipe(map(response => response),
        catchError((error, caught) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }
}
